// Stratia's brand line (founder, chat 2026-10-23, option A of Desk request
// R-29): the home page's headline, the line under the brand in every public
// page's footer, the News article's closing box, the share card and
// index.html's head. It replaced "Build something real. The profile
// follows.", which now names only the builder tools (STORY_BUILD).
// Import-free, so the footer on every public page can read it without
// pulling the landing page's content in. index.html and
// marketing/generate_og_card.py cannot import it: brandLine.test.js and
// tests/marketing/test_og_card.py pin them to it.
export const STORY_TAGLINE = 'Start with your story. See where it fits.';
